import axios from 'axios';
import {
  GET_THROWBACK_COUPON_REQUEST,
  GET_THROWBACK_COUPON_SUCCESS,
  GET_THROWBACK_COUPON_FAILURE
} from 'Store/constants';
import errorMessage from './errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getThrowbackCoupon = couponId => async dispatch => {

  try {
    dispatch({
      type: GET_THROWBACK_COUPON_REQUEST
    });

    const requestUrl = couponId ? `throwback-coupons/coupon/${couponId}` : 'throwback-coupons/coupon/customer';
    const res = await axios.get(`${API_GATEWAY}/${requestUrl}`);

    dispatch({
      type: GET_THROWBACK_COUPON_SUCCESS,
      payload: res.data.coupons?.[0]
    });

  } catch (e) {

    dispatch({
      type: GET_THROWBACK_COUPON_FAILURE,
      payload: errorMessage
    });
  }
};
